export function Error({ children }) {
  return (
    <div className="text-red  px-4 py-2 border-0 rounded relative mb-4 bg-red-light">
      {children}
    </div>
  );
}

export function Success({ children }) {
  return (
    <div className="text-green px-4 py-2 border-0 rounded relative mb-4 bg-green-light">
      {children}
    </div>
  );
}
